<template>
    <el-dialog title="国际运单" :visible.sync="DetaileddisShow" width="60%" append-to-body>
        <!-- 国际运单明细 -->
        <div class="inner-goods clear">
            <img
                src="http://ecx.images-amazon.com/images/I/41buxSclv7L._SL75_.jpg"
                alt
                class="inner-goods-img"
            />
            <div class="inner-goods-text">
                <el-link
                    class="line-height"
                >Divano Reclinabile a L,Versatile Sofà con bracciolo,Chaise Longue e Telaio in MDF,per in Camera da Letto o Soggiorno,Rivestimento in Tessuto 171.5x138x81.5 cm Verde</el-link>
                <p class="line-height">
                    <label for>SKU:</label>SEART000001-uk-Pineapple-60x150cm
                    <label class="label-l" for>数量:</label>1
                </p>
            </div>
        </div>
        <div class="el-row" style="margin-top: 10px;">
            <div class="el-col el-col-7">
                <label for class="el-form-item__label" style="width: 31%;">产品中文</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <label for class="el-form-item__label" style="width: 38%;">海关品名(英文)</label>
                <el-input v-model="input" :disabled="true" style="width: 60%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <a href style="width: 31%;padding: 0 15px 0 0;">海关编号(HS)</a>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
            </div>
        </div>
        <div class="el-row" style="margin-top: 10px;">
            <div class="el-col el-col-7">
                <label for class="el-form-item__label" style="width: 31%;">申报数量</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <label for class="el-form-item__label">申报单价</label>
                <el-input
                    placeholder="请输入内容"
                    v-model="input3"
                    :disabled="true"
                    class="input-with-select"
                    style="width: 75%;margin-top: 5px;"
                >
                    <el-select
                        v-model="select"
                        slot="prepend"
                        placeholder="请选择"
                        style="width: 100px;"
                    >
                        <el-option label="餐厅名" value="1"></el-option>
                        <el-option label="订单号" value="2"></el-option>
                        <el-option label="用户电话" value="3"></el-option>
                    </el-select>
                </el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <label for class="el-form-item__label" style="width: 31%;">申报总值</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
        </div>
        <div class="el-row" style="margin-top: 10px;">
            <div class="el-col el-col-7">
                <label for class="el-form-item__label" style="width: 31%;">申报重量</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <label for class="el-form-item__label">申报体积</label>
                <el-input v-model="input" :disabled="true" style="width: 18%; line-height: 40px;"></el-input>&nbsp;&nbsp;X&nbsp;&nbsp;
                <el-input v-model="input" :disabled="true" style="width: 18%; line-height: 40px;"></el-input>&nbsp;&nbsp;X&nbsp;&nbsp;
                <el-input v-model="input" :disabled="true" style="width: 18%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-7 el-col-offset-1">
                <label for class="el-form-item__label" style="width: 31%;">销售链接</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
        </div>
        <div class="el-row border-bottom" style="margin-top: 10px;padding-bottom: 10px;">
            <div class="el-col el-col-12">
                <label for class="el-form-item__label" style="width: 17%;">运单</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
            <div class="el-col el-col-11">
                <label for class="el-form-item__label" style="width: 17%;">追踪</label>
                <el-input v-model="input" :disabled="true" style="width: 65%; line-height: 40px;"></el-input>
            </div>
        </div>
        <div class="el-row" style="margin-top: 10px;">
            <div class="el-col el-col-12">
                <label for class="el-form-item__label" style="width: 31%;">添加备注:</label>
                <el-input v-model="input" style="width: 65%; line-height: 40px;"></el-input>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="DetaileddisShow = false">取消</el-button>
            <el-button type="primary" @click="DetailedDetermine">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "FBMOrder",
    data() {
        return {
            radio: 0,
            value: "",
            input: "",
            input3: "",
            select: "",
            DetaileddisShow: false
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        init() {
            this.DetaileddisShow = true;
        },
        handleSizeChange() {},
        handleCurrentChange() {},
        // 点击明细确定
        DetailedDetermine() {
            this.DetaileddisShow = false;
        }
    }
};
</script>
<style lang="scss">
.inner-goods {
    overflow: hidden;
    padding: 5px 0;
    border-bottom: 1px solid #eee;
    .inner-goods-img {
        width: 80px;
        height: 80px;
        float: left;
        margin-right: 10px;
    }
    .inner-goods-text {
        width: 60%;
        float: left;
        line-height: 30px;
        white-space: nowrap;
        overflow: hidden;
    }
}
</style>
